(function(){
    'use strict';

    angular
    .module('appback')
    .controller('SerotecaContoller', SerotecaContoller)
 
    SerotecaContoller.$inject = ["SerotecaService","GenerallabService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function SerotecaContoller(SerotecaService,GenerallabService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this;

        vm.printService = new WebSocketPrinter();

        vm.printRaw = function(value) {
            vm.printService.submit({
                'type': 'INVOICE',
                'raw_content': value
            });
        };

        vm.generalLab = GenerallabService;
        vm.racks = []; 
        vm.id_muestra = "";
        vm.searcher = {};
        vm.init = function(){
        	SerotecaService.getSerotecas('',function(data){
        		vm.racks = data.serotecas;
        	})
	    }
        vm.addCongelador = function(){
            vm.racks.push({nombre:"Congelador "+(vm.racks.length+1),soportes:[]});
        }
	    vm.addRack = function(congelador){
            //console.log(congelador);
            if(typeof(congelador.soportes)=='undefined'){
                congelador.soportes = [];
            }
	    	congelador.soportes.push({subracks:[{}],num_max:10});
	    }

        vm.addSubRack = function(rack){
            rack.subracks.push({});
        }

        vm.printRack = function(rack,subrack,posicion){
            SerotecaService.printRack(rack,subrack,posicion,function(data){
                vm.printRaw(data.print);
            });
        }

        vm.saveSoportes = function(congelador){
            SerotecaService.saveSoportes(congelador,function(data){
                vm.racks = data.serotecas;
            })
        }

        vm.buscarMuestra = function(){
            SerotecaService.buscarMuestra(vm.id_muestra,function(data){
                //vm.racks = data.serotecas;
                //console.log(vm.searcher);
                vm.searcher = data;
            })
        }


    }
  
})();